var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.web3.blockNumber)?_c('span',{staticClass:"State",class:_vm.state.class,domProps:{"textContent":_vm._s(_vm.state.name)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }